import { LogActiveUserAPI } from "../api"

export class LogActiveUser {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createLogActiveUser(marketId) {
    const { data } = await LogActiveUserAPI.createLogActiveUser(marketId);
    return new LogActiveUser(data)
  }
}